import { Component, OnInit } from '@angular/core';
import { ToastService } from '../../../core/services/toast.service';
import { AuthService } from '../../../core/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiError } from '../../../core/models/common/api-error';
import { RoomPermission } from '../../../core/models/entities/permission';
import { Store } from '@ngrx/store';
import { authActions } from 'angular/app/core/store/auth';

@Component({
  selector: 'app-two-factor-auth-page',
  template: `<app-loader [centered]="true"></app-loader>`,
  standalone: false,
})
export class TwoFactorAuthPageComponent implements OnInit {
  constructor(
    private toastService: ToastService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private store: Store,
  ) {}

  async ngOnInit() {
    const token = this.route.snapshot.queryParams['token'];
    try {
      const response = await this.authService.token(token);
      this.store.dispatch(authActions.loginSuccess(response));
      if (
        !response.user.vendor.has_rooms &&
        response.user.all_permissions.includes(RoomPermission.Store)
      ) {
        await this.router.navigate(['/salles']);
      } else {
        await this.router.navigate(['/reservations']);
      }
    } catch (exception) {
      this.toastService.error((exception as ApiError).message);
      await this.router.navigate(['/']);
    }
  }
}
